module.exports = __webpack_public_path__ + "img/emptyPlan.d45d65fd.png";